<template>
  <div>
    <b-tooltip position="is-left" :label="$t('sondage.addpropsition')">
      <div @click="addProposition">
        <img
          src="@/assets/img/icons/create.png"
          style="margin-left:5px;"
          class="icon"
          alt="icon-drop"
        />
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    addProposition (evt) {
      this.$store.commit('ADD_PROPOSITION', this.question)
      this.$store.commit('TEST_SAVE_ANSWERS_BUTTON')
      this.$buefy.toast.open({
        message: this.$i18n.t('toast.question.add-proposition'),
        type: 'is-success'
      })
    }
  },
  props: {
    question: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.icon {
  width: 25px;
  height: 25px;
  margin-top: 20px;
  vertical-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/AddPropositionButton.vue